import { makeStyles, createStyles, MuiTheme } from '@kis-technologies/kis-ui';

export const useStyles = (props: { fontFamily?: string; hasPromo?: boolean }) =>
  makeStyles((theme: MuiTheme) =>
    createStyles({
      tierSelectionContainer: {
        justifyContent: 'center',
        padding: '0px 24px 24px 24px',
        background: 'transparent',
        minWidth: '100%'
      },
      tierSelectInnerContainer: {
        background: 'white',
        color: '#2A2A2A',
        minWidth: '100%',
        borderRadius: '8px',
        height: '809px',
        boxShadow: '0 3px 9px 0 rgba(0,0,0,0.2)',
        overflow: 'hidden',
        padding: '32px 60px 32px',
        [theme.breakpoints.down('lg')]: {
          height: '1640px',
          padding: '32px 30px 32px'
        }
      },
      contentBlock: {
        height: '600px',
        background: 'transparent',
        [theme.breakpoints.down('lg')]: {
          padding: '0px 15px 25px 15px',
          height: props.hasPromo ? '1325px' : '1425px'
        },
        '& > *': {
          margin: '0px 0px 0px 0px'
        }
      },
      tierHeaderOuterBlock: {
        display: 'flex',
        minWidth: '100%',
        margin: '0 0 16px',
        flexDirection: 'row',
        [theme.breakpoints.down('lg')]: {
          flexDirection: 'column'
        }
      },
      tierHeaderBlock: {
        flex: '1 1 0%',
        background: 'transparent',
        [theme.breakpoints.down('lg')]: {
          paddingLeft: '27px'
        }
      },
      ticketHeader: {
        fontWeight: 600,
        fontSize: '56px',
        margin: '0px',
        fontFamily: props.fontFamily,
        letterSpacing: 'normal',
        [theme.breakpoints.down('lg')]: {
          fontSize: '48px'
        }
      },
      ticketSubHeading: {
        [theme.breakpoints.down('lg')]: {
          width: '100%'
        }
      },
      tierSelectionLabelText: {
        display: 'flex',
        flexDirection: 'row',
        background: 'transparent',
        minWidth: '100%'
      },
      eventTierCardImage: {
        background: 'transparent',
        display: 'flex',
        flex: '1 0 366px',
        height: '275px',
        [theme.breakpoints.down('lg')]: {
          flex: '0 1 400px',
          height: '300px',
          justifyContent: 'center'
        }
      },
      eventTierImage: {
        width: '100%',
        height: '100%',
        objectFit: 'cover',
        borderRadius: '8px 0px 0px 0px',
        [theme.breakpoints.down('lg')]: {
          borderRadius: '0px 0px 0px 0px'
        }
      },
      eventTierCardContent: {
        display: 'flex',
        flexDirection: 'row',
        border: 'solid 1px #D8D8D8',
        background: 'transparent',
        height: 'auto',
        flexWrap: 'nowrap',
        borderRadius: '8px 0px 0px 0px',
        [theme.breakpoints.down('lg')]: {
          height: 'auto',
          flexWrap: 'wrap',
          justifyContent: 'center',
          padding: '24px 0 0'
        }
      },
      eventTierDataContainer: {
        width: '100%',
        padding: '0px 32px 40px',
        [theme.breakpoints.down('lg')]: {
          padding: '10px 30px 30px'
        }
      },
      eventTierCardData: {
        display: 'flex',
        flexDirection: 'column',
        padding: '10px 0px 16px 0px',
        [theme.breakpoints.down('lg')]: {
          width: '100%'
        }
      },
      eventTierCardHeading: {
        fontWeight: 600,
        fontSize: '54px',
        margin: '0px',
        fontFamily: props.fontFamily,
        letterSpacing: 'normal',
        [theme.breakpoints.down('lg')]: {
          fontSize: '48px'
        }
      },
      eventTierCardSubHead: {
        fontSize: '24px',
        margin: '0px',
        fontFamily: props.fontFamily,
        letterSpacing: 'normal'
      },
      eventTierCardBody: {
        fontWeight: 600,
        fontSize: '24px',
        margin: '0px',
        fontFamily: props.fontFamily,
        letterSpacing: 'normal'
      },
      tierCheckBoxContainer: {
        display: 'grid',
        gridAutoRows: '1fr',
        gap: '25px'
      }
    })
  );
